var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from "clsx";
import React, { forwardRef } from "react";
/**
 * A component that displays a bordered panel with heading and body.
 *
 * @see [📝 Documentation](https://aksel.nav.no/komponenter/core/panel)
 * @see 🏷️ {@link PanelProps}
 * @see [🤖 OverridableComponent](https://aksel.nav.no/grunnleggende/kode/overridablecomponent) support
 *
 * @example
 * ```jsx
 * <Panel border>
 *   <Heading spacing level="2" size="large">
 *     Søk om økonomisk sosialhjelp
 *   </Heading>
 *   <BodyLong>
 *     Du kan søke om det du trenger økonomisk støtte til.
 *   </BodyLong>
 * </Panel>
 * ```
 */
export const Panel = forwardRef((_a, ref) => {
    var { children, className, border = false, as: Component = "div" } = _a, rest = __rest(_a, ["children", "className", "border", "as"]);
    return (React.createElement(Component, Object.assign({ ref: ref, className: cl("navds-panel", className, {
            "navds-panel--border": border,
        }) }, rest), children));
});
export default Panel;
//# sourceMappingURL=Panel.js.map